module.exports = __webpack_public_path__ + "static/media/Building Nature.4cbc5e41.svg";